const NL = {
  associationIncorporated: [
    "vereniging",
    "coöperatie"
  ],
  partnershipUnincorporated: [
    "vennootschap onder firma (VOF)",
    "maatschap",
    "commanditaire vennootschap (CV)"
  ]
};
export {
  NL as default
};
